import { CoreIcon } from '../core-icon';
import arrowLeftSVG from '../../assets/icons/arrow-left.svg';
import type { IconProps } from '../core-icon';

export const ArrowLeftIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={arrowLeftSVG} {...props} />;
};
